"use strict";var e=require("styled-components");require("../../providers/Theme/defaultTheme.js");var o=require("../../utilities/theme/createStyles/index.js");const r=e.css`
    color: ${({color:e,theme:o})=>e||("light"===o.mode?o.colors.common.dark:o.colors.common.light)};

    ${({theme:e,variant:r="p"})=>{var t;const s=(null===(t=e.typography)||void 0===t?void 0:t[r])||{};return o(s)}};
`;module.exports=r;
//# sourceMappingURL=styles.js.map
